import { SilentRequest } from "@azure/msal-browser";
import { initializeMsalInstance, msalInstance } from "./msalInstance";
import redirectUrl from "./redirectUrl";

export const rppAuthScope : string = globalThis.config.rpp_scope;

export const hasAdminRole = () => {
    return hasAccountRole(['admin']);
}

const hasAccountRole = (roleNames: string[]) => {
    const accounts = msalInstance.getAllAccounts();

    if (!accounts || accounts.length === 0) {
        return false;
    }
    const account = accounts[0];
    if (!account.idTokenClaims || !account.idTokenClaims.roles || account.idTokenClaims.roles.length === 0) {
        return false;
    }
    const roles = account.idTokenClaims.roles;
    return roles.some(r => roleNames.some(rn => r.toUpperCase() == rn.toUpperCase()));
}

export const getAccessToken = async (scopes: string[]) => {
    await initializeMsalInstance();
    const account = msalInstance.getAllAccounts()[0];
    const silentRequest: SilentRequest = { scopes, account };

    const tokenResponse = await msalInstance.acquireTokenSilent(silentRequest).catch(async (error) => {
        console.log('failed to acquire access token!', error);
        redirectUrl.set(`${location.pathname}${location.search}`);
        msalInstance.clearCache();
    });
    return tokenResponse?.accessToken;
}
